import { CommonEnums } from 'src/app/shared/common.enums';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { Fltr_Inst } from './fltr_inst';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';

export class Filter {
    fltr_Inst: Fltr_Inst;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    fldr_Id: number;
    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    is_In_SubFlow: string;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;

    gen_Tab_Change_Ind: string;
    prop_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.fltr_Inst = new Fltr_Inst();

        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_VAL_NO;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
    }

    static parse(filterTmp: Filter): Filter {
        let filter: Filter = new Filter();
        filter.copyFrom(filterTmp);
        return filter;
    }

    copy(): Filter {
        let filterTmp: Filter = new Filter();

        filterTmp.fltr_Inst = this.fltr_Inst.copy();
        filterTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        filterTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        filterTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        filterTmp.ref_Id = this.ref_Id;
        filterTmp.ref_Cd = this.ref_Cd;
        filterTmp.fldr_Id = this.fldr_Id;
        filterTmp.is_In_SubFlow = this.is_In_SubFlow;
        filterTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;

        filterTmp.change_Ind = this.change_Ind;
        filterTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        filterTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        filterTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        filterTmp.error_Cd = this.error_Cd;
        filterTmp.error_Msg = this.error_Msg;

        return filterTmp;
    }

    copyFrom(filterTmp: Filter): void {
        this.fltr_Inst.copyFrom(filterTmp.fltr_Inst);

        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, filterTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, filterTmp.runPropertyTypes);

        this.nativeDbTyp_Id = filterTmp.nativeDbTyp_Id;
        this.ref_Id = filterTmp.ref_Id;
        this.ref_Cd = filterTmp.ref_Cd;
        this.fldr_Id = filterTmp.fldr_Id;
        this.is_In_SubFlow = filterTmp.is_In_SubFlow;
        this.sel_Run_PropertyType_Cd = filterTmp.sel_Run_PropertyType_Cd;

        this.change_Ind = filterTmp.change_Ind;
        this.prop_Tab_Change_Ind = filterTmp.prop_Tab_Change_Ind;
        this.gen_Tab_Change_Ind = filterTmp.gen_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = filterTmp.rProp_Tab_Change_Ind;

        this.error_Cd = filterTmp.error_Cd;
        this.error_Msg = filterTmp.error_Msg;
    }

    compare(filterTmp: Filter): string {
        let diffString: string = this.fltr_Inst.compare(filterTmp.fltr_Inst);
        if (diffString != '') return diffString;

        diffString = this.toBaseCompare(filterTmp);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, filterTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, filterTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(filterTmp: Filter): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = filterTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str = "Filter [fltr_Inst=" + this.fltr_Inst.toString() + this.toBaseString() +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd + ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind +
                ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind + ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }

    toBaseString(): string {
        return ", fldr_Id=" + this.fldr_Id + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", is_In_SubFlow=" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd;
    }
}




















